// import { GraphQLClient, gql } from 'graphql-request';
// Converted this to CommonJS to support cypress without having to rewrite
// const { GraphQLClient, gql } = require('graphql-request');
import axios from 'axios';

// Note: ap-northeast-1.cdn.hygraph.com/content is the high-performance read-only endpoint.
// If you need to do mutations, please use api-ap-northeast-1.hygraph.com/v2 instead.
const urlRO = 'https://ap-northeast-1.cdn.hygraph.com/content/ckuqotonf16hn01w8ahut8o1m/master';
const urlRW = 'https://api-ap-northeast-1.hygraph.com/v2/ckuqotonf16hn01w8ahut8o1m/master';

const baseRequest = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'gcms-stage': process.env.NEXT_PUBLIC_ENV === 'prod' ? 'PUBLISHED' : 'DRAFT',
  },
});

baseRequest.interceptors.response.use(undefined, (error) => {
  if (error?.response?.data?.errors)
    error.response.data.errors = JSON.stringify(error.response.data.errors);
  throw error;
});

export const postToHygraph = async (query, variables, preview) => {
  const { data } = await baseRequest.post(preview ? urlRW : urlRO, {
    query: query,
    ...(!!variables && { variables: variables }),
  });
  return data?.data;
};
